<template>

	<div class="main">
		
		<div class="logo" :style="{opacity: opacityLogoBg}">
			<img src="../assets/om-logo-bg.png"></img>
		</div>	
		
		<div class="logo" :style="{opacity: opacityLogo}">
			<img src="../assets/om-logo.png"></img>
		</div>
			
		<div class="main_inner">
		
			
			
			<h1>Die Benefiz-Tanzshow</h1>
			<h1 class="subtitle">zu gunsten des &shy; EV.&nbsp;Kinderheims&nbsp;Burscheid & <br /> Ökumenisches&nbsp;Hospiz Burscheid&nbsp;E.V.</h1>
			

			<div class="row row--date">
				<p class="row--date__container">Samstag<span class="date">9. November 2019</span> 19.30 Uhr<span class="sold-out">Ausverkauft</span></p>
				<p class="row--date__container">Sonntag<span class="date">10. November 2019</span> 18.00 Uhr<span class="sold-out">Ausverkauft</span></p>			
			</div>
			
			<div class="row">
				<h3><span style="display: block; margin-bottom: 5px; text-transform: none">präsentiert von</span>Diwan El Shark - Das Tanzstudio in Burscheid</h3>
				<h3><span style="display: block; margin-bottom: 5px; text-transform: none">mit unseren exklusiven Gasttänzerinnen</span>Apsara Habiba, Dunyazade & Shahrazad</h3>
			</div>
			
			<div class="row">
			
				<div class="row__container half left" v-in-viewport.once>
					<h2>Das erwartet Sie</h2>
					Lassen Sie sich an einem unvergesslichen Abend in unserer orientalischen Tanzshow verzaubern. Erleben Sie abwechslungsreiche Tänze, bunte Kostüme und eine beeindruckende Atmosphäre, erfüllt mit der Magie aus 1001 Nacht. Die Tänzerinnen unseres Studios Diwan El Shark sowie unsere über die Grenzen Deutschlands bekannten Gasttänzerinnen Apsara Habiba, Dunyazade und Shahrazad nehmen Sie mit auf eine magische Zeitreise durch den Orient.
				</div>

				<div class="row__container half right" v-in-viewport.once>
					<h2>Unsere Motivation</h2>
					Mit dieser Veranstaltung wollen wir zwei Ziele verbinden. Zum einen wollen wir Ihnen einen besonderen Abend im Haus der Kunst in Burscheid bereiten, zum anderen möchten wir diejenigen in unserer Stadt unterstützen, die anderen Menschen in Not und schwierigen Lebenslagen helfen und begleiten. Deswegen spenden wir den Erlös unserer Veranstaltung zu Gunsten des evangelischen Kinderheims Burscheid und des ökumenischen Hospiz Burscheid e.V. 
				</div>
				
				<div class="row__container half left" v-in-viewport.once>
					<h2>Der Ort der Veranstaltung</h2>
					<p>Haus der Kunst, Höhestraße 5, 51399 Burscheid <br />Bitte beachten Sie, dass nur eine begrenzte Anzahl an Parkplätzen vorhanden ist.</p>
					<location-map></location-map>
				</div>
				
				<div class="row__container half right tickets" v-in-viewport.once>
					<h2>Ihre Eintritts&shy;karte in den Orient</h2>
					<p>Sichern Sie sich jetzt Ihre Karte für die Benefiz-Tanzshow Oriental Magic und erleben Sie einen unvergesslichen Abend im Haus der Kunst:</p>
					<ul>
						<li class="icon adress">Buchhandlung Ute Hentschel <span class="adress">Hauptstraße 26, 51399 Burscheid</span></li>
						<li class="icon">Rathaus Stadt Burscheid <span class="adress">Höhestraße 7 - 9, 51399 Burscheid</span></li>
						<li class="icon">Getränke Fuchs <span class="adress">Bahnhofstraße 1, 51399 Burscheid</span></li>
						<li class="icon">Diwan El Shark - Das Tanzstudio <span class="adress">Hauptstraße 69, 51399 Burscheid</span></li>
					</ul>
						
					<b class="icon phone">0179 / 5 12 83 24</b>
					
					<div class="prices">
						<div><b>Vorverkauf:</b> 18,00 €</div>
						<div><b>Abendkasse:</b> 20,00 €</div>
					</div>					
				</div>

				<div class="row__container full left" v-in-viewport.once>
					<h2>Unsere vergangenen Veranstaltungen</h2>
					<image-carousel :images="thumbnails" v-on:imageId="openZoomerGallery"></image-carousel>
				</div>	
				
			</div>	
					
			<footer>
				<span class="copyright">© Diwan El Shark 2019</span>
				<div class="links">
					<a href="/datenschutz">Datenschutz</a>
					<a href="/impressum">Impressum</a>
				</div>		
			</footer>
			
		</div>
		
		<div v-if="zoomerVisible" @keyup.esc="closeZoomerGallery">
			<v-zoomer-gallery :list="images" v-model="zoomerImageId" class="zoomer-gallery"></v-zoomer-gallery>
			<button class="zoomer-gallery-close" @click="closeZoomerGallery">ZURÜCK</button>
		</div>
		
	</div>
	
</template>



<script>

	import LocationMap from '../components/LocationMap.vue';
	import ImageCarousel from '../components/ImageCarousel.vue';
	

	export default {
	
		data: () => ({
		
			images: [
				'https://www.diwan-el-shark.de/images/gallery/2011-04-09-oriental-dreams/Oriental-Dreams-Bild_15.jpg',			
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(18).jpg',
				'https://www.diwan-el-shark.de/images/gallery/2011-04-09-oriental-dreams/Oriental-Dreams-Bild_24.jpg',
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(75).jpg',
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(10).jpg',
				'https://www.diwan-el-shark.de/images/gallery/2011-04-09-oriental-dreams/Oriental-Dreams-Bild_09.jpg',
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(52).jpg',
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(70).jpg',				
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(04).jpg',
				'https://www.diwan-el-shark.de/images/gallery/2011-04-09-oriental-dreams/Oriental-Dreams-Bild_17.jpg',
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(56).jpg',
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(68).jpg',	
				'https://www.diwan-el-shark.de/images/gallery/2011-04-09-oriental-dreams/Oriental-Dreams-Bild_27.jpg',				
			],
			
			thumbnails: [
				'https://www.diwan-el-shark.de/images/gallery/2011-04-09-oriental-dreams/Oriental-Dreams-Bild_15-thumbnail.jpg',			
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(18)-thumbnail.jpg',
				'https://www.diwan-el-shark.de/images/gallery/2011-04-09-oriental-dreams/Oriental-Dreams-Bild_24-thumbnail.jpg',
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(75)-thumbnail.jpg',
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(10)-thumbnail.jpg',
				'https://www.diwan-el-shark.de/images/gallery/2011-04-09-oriental-dreams/Oriental-Dreams-Bild_09-thumbnail.jpg',
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(52)-thumbnail.jpg',
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(70)-thumbnail.jpg',				
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(04)-thumbnail.jpg',
				'https://www.diwan-el-shark.de/images/gallery/2011-04-09-oriental-dreams/Oriental-Dreams-Bild_17-thumbnail.jpg',
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(56)-thumbnail.jpg',
				'https://www.diwan-el-shark.de/images/gallery/2016-10-29-oriental-elements/oriental_elements_(68)-thumbnail.jpg',
				'https://www.diwan-el-shark.de/images/gallery/2011-04-09-oriental-dreams/Oriental-Dreams-Bild_27-thumbnail.jpg',				
			],			
			
			zoomerVisible: false,
			zoomerImageId: 1,
			
			opacityLogo: 1,
			opacityLogoBg: 1,
			opacityPresentDES: 0,
		
		}),

		
		
		components: {
			LocationMap,
			ImageCarousel
		},
		
		
		
		methods: {
			
			openZoomerGallery (imageId) {
				this.zoomerImageId = imageId;
				this.zoomerVisible = true;
				document.addEventListener('keyup', this.handleKeyUp);
			},
			
			
			closeZoomerGallery () {
				this.zoomerVisible = false;
				document.removeEventListener('keyup', this.handleKeyUp);				
			},
			
			
			handleKeyUp (event) {
				if (event.keyCode === 27) { 
					this.closeZoomerGallery(); 
				}
				
				else if (event.keyCode === 39) {
					this.zoomerImageId = (this.zoomerImageId < (this.images.length - 1)) ? this.zoomerImageId + 1 : 0;
				}
				
				else if (event.keyCode === 37) {
					this.zoomerImageId = (this.zoomerImageId > 0) ? this.zoomerImageId - 1 : this.images.length - 1;
				}
			},
			
			
			handleScroll () {
				window.scrollY = window.pageYOffset;
				let windowVh = (window.scrollY / window.innerHeight) * 100;
				
				if (windowVh < 50) {
					this.opacityPresentDES = (windowVh == 0) ? 0 : (windowVh / 50 );
					this.opacityLogo = (windowVh == 0) ? 1 : 1 - (windowVh / 50 );
				} else {
					this.opacityLogo = 0;
					this.opacityPresentDES = 1;
				}
				
				if (windowVh < 200) {
					this.opacityLogoBg = (windowVh < 100) ? 1 : 1 - ( (windowVh - 100) / 100 );
				} else {
					this.opacityLogoBg = 0;
				}
			}
		},
		
		
		
		created () {
			window.addEventListener('scroll', this.handleScroll, { capture: false, passive: true } );
		},
		
		
		
		destroyed () {
			window.removeEventListener('scroll', this.handleScroll);
		},
		
	}
	
</script>



<style lang="scss">
	
	$container-margin: 40px;

	html {
		width: 100%;
		height: 100%;
		background-image: url('../assets/bg.jpg');
		background-color: #000;
		background-repeat: no-repeat;
		background-attachment: fixed;
		background-position: center top;
		background-size: cover;

	}
	
	body {
		background-color: transparent;
		color: rgb(255,255,255);
	}
	
	h1 {
		margin: 0px;
		padding: 0px 0px;
		font-size: 2.75rem;
		font-weight: normal;
		text-transform: uppercase;
		letter-spacing: 5px;
		text-align: center;

		&:first-of-type {
			padding-top: 85vh;

		}

		&.subtitle {
			font-size: 1.3rem;
			letter-spacing: 0px;
			padding:0px 10%;
		}
	}

	h2 {
		margin-bottom: 25px;
		text-transform: uppercase;
		text-align: left;
		letter-spacing: 2px;		
		line-height: 0.95;
	}
	
	h3 {
		margin-bottom: 50px;
		padding: 0px 30px;
		font-size: 1.3rem;
		font-weight: normal;		
		text-transform: uppercase;
		text-align: center;	
			
		&:last-of-type {
			margin-bottom: 100px;
		}
	}
	
	.main {
		position: relative;
		min-height: 100vh;
	}
	
	.logo {
		position: fixed;	
		width: 100%;
		text-align: center;
		
		img {
			height: 85vh;
			width: auto;
			max-width: 100vw;
			object-fit: contain;
		}
	}
	
	.main_inner {
		position: relative;
		max-width: 1200px;
		margin: auto;
		box-sizing: border-box;
		overflow: hidden;
	}
	
	.row {
		display: flex;		
		flex-direction: column;
		margin-bottom: 100px;
		color: white;
		
		&__container {
			padding-bottom: 180px;
			padding-left: 60px;
			padding-right: 60px;
			text-align: justify;
			font-size: 1.1rem;
			opacity: 0;
			background-image: url(../assets/om-sand.png);
			background-repeat: no-repeat;
			background-position: -100px bottom;

			
			&.half {
				width: 60%;
				background-size: 100%;				
			}
			
			&.full {
				width: 100%;
				background-size: 50%;				
			}

			&.left {
				align-self: flex-start; 
				transform: translateX(-50px)
			}
			&.right {
				align-self: flex-end; 
				transform: translateX(50px);
			}	
			
			&.in-viewport {
				opacity: 1;
				transform: translateX(0px);
				transition: all 1s ease-in-out;
			}
			
		}
		
		&--date {
			display: flex;		
			justify-content: space-around;
			flex-direction: row;
			font-size: 20px;
			padding-top: 15vh;
			padding-bottom: 15vh;
			
			&__container {
				position: relative;
				margin: 100px auto 50px auto;
				font-size: 1.7rem; /* 1.6 */			
				line-height: 1.4; /* 1.2 */
				text-align: center;
					
				.date {
					display: block;
					font-size: 1.9rem; /* 1.3 */
					font-weight: bold;
					text-transform: uppercase;
				}
				
				.sold-out {
					display: block;
					position: absolute;
					top: 70%;
					right: -4%;
					background: rgb(189, 0, 0) none repeat scroll 0% 0%;
					padding: 2px 10px;
					text-transform: uppercase;
					font-size: 1.25rem;
					font-weight: bold;
					transform: rotate(-20grad);
				}
			}
				
		}			
				
	}

	
	ul {
		padding: 0;
		margin: 0;
		list-style: none;
	}
	
	.tickets li {
		margin-bottom: 30px;
		font-weight: bold;

		&:not(.adress) {
			padding-left: 40px;
		}
	}

	.tickets span.adress {
		display: block;
		font-weight: normal;
		line-height: 0.8;
	}

	.icon.adress:before, 
	.icon.phone:before {
		content: "";
		display: block;
		float: left;
		height: 30px;
		width: 40px;
		background-repeat: no-repeat;
		background-position: left center;
	}	

	.icon.phone:before { background-image: url("../assets/phone.png"); }
	.icon.adress:before { background-image: url("../assets/adress.png"); }

	.icon.phone {
		line-height: 30px;
	}
	
	.tickets .prices {
		display: flex;
		flex-wrap: wrap;
		margin-top: 30px;
		
		& > div:not(:last-of-type) {
			margin-right: 50px;
		}
	}
	
	footer {
		display: flex;
		justify-content: space-between;
		padding: 10px 60px;
		color: rgb(255,255,255);
		
		a {
			color: rgb(255,255,255);
			
			&:last-of-type {
				margin-left: 20px;
			}
			
			&:hover {
				color: rgb(255,255,255);
				text-decoration: underline;
			}
		}
	}
	
	
	@media only screen and (max-width: 1240px) {
	
		.main_inner {
			padding: 0px 20px;
		}
		
	}
	
	
	@media only screen and (max-width: 900px) {
	
		.row {
			
			&__container {
				padding-bottom: 180px;
				padding-left: 60px;
				background-position: -100px bottom;

				&.half {
					width: 100%;		
				}
			}
			
			&--date {
				display: flex;
				flex-direction: column;
			}
		}
	}

	
	@media only screen and (max-width: 600px) {

		html {
			font-size: 14px;
		}
	
		.main_inner {
			padding: 0px 0px;
		}
		
		.logo img {
			height: 70vh;
		}
		
		h1 {
			font-size: 1.8rem;
			letter-spacing: 0px;
			line-height: 0.95;
			margin-bottom: 10px;			

			&:first-of-type {
				padding-top: 70vh;
			}
			
			&.subtitle {
				font-size: 1.2rem;
				line-height: 1.2;
			}
		}
		
		h3 {
			margin-bottom: 15vh;
			
			&:last-of-type {
				margin-bottom: 15vh;
			}
		}
		
		.tickets li {
			margin-top: 20px;
		}	
			
		.row {
			
			&__container {
				margin-bottom: 30px;
				padding-bottom: calc(100vw / 4);
				padding-left: 30px;
				padding-right: 30px;
				background-position: -100px bottom;
				text-align: left;

				&.half {
					width: 100%;		
				}
				
				&.full {
					background-size: 100%;				
				}
			}
			
			&--date {
				margin-bottom: 0;
			}
		}
		
		footer {
			padding: 10px;
		}
	}

	.zoomer-gallery {
		position: fixed !important; 
		top: 0; 
		left: 0; 
		width: 100vw; 
		height: 100vh;
		background-image: linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url('../assets/bg.jpg');
		background-color: #000;
		background-repeat: no-repeat;
		background-attachment: fixed;
		background-position: center top;
		background-size: cover;	
	}
	
	.zoomer-gallery-close {
		appearance: none;
		-moz-appearance: none;
		-webkit-appearance: none;
		border: none;		
		
		position:fixed;
		top: 10px;
		left: 10px;
		height: 50px;
		color: rgb(255,255,255);
		font-size: 25px;

		background-image: url("../assets/arrow.svg");
		background-position: left;
		background-repeat: no-repeat;
		background-color: transparent;
		background-size: contain;

		line-height: 50px;
		cursor: pointer;
		padding-left: 30px;
	}
	
</style>
